/* eslint-disable no-useless-escape */
import React, { forwardRef, useEffect, useState } from 'react';

import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { pt } from 'date-fns/locale';

import { ButtonProps } from '@material-ui/core';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import { BiCalendar, BiX } from 'react-icons/bi';

import Button from '../../../../newComponents/Button';
import * as S from './styles';

import api from '../../../../services/api';
import { useAuth } from '../../../../hooks/auth';
import { useToast } from '../../../../hooks/toast';

registerLocale('pt-BR', pt);

interface IScheduledDeliveryDays {
  dom: string[];
  seg: string[];
  ter: string[];
  qua: string[];
  qui: string[];
  sex: string[];
  sab: string[];
}

interface ModalSchedulingProps {
  onClose: () => void;
  setScheduledDelivery: React.Dispatch<React.SetStateAction<Date | null>>;
}

const CustomButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ value, onClick }, ref) => {
    return (
      <S.CustomCaledar type="button" onClick={onClick} ref={ref}>
        <p>{value}</p>
        <BiCalendar size={20} />
      </S.CustomCaledar>
    );
  },
);

const ModalScheduling: React.FC<ModalSchedulingProps> = (props) => {
  const { onClose, setScheduledDelivery } = props;

  const { user } = useAuth();
  const { addToast } = useToast();

  const [
    scheduledDeliveryDays,
    setScheduledDeliveryDays,
  ] = useState<IScheduledDeliveryDays | null>(null);
  const [hoursOptions, setHoursOptions] = useState<string[]>([]);
  const [selectedHour, setSelectedHour] = useState<string | null>(null);
  const [selectedDay, setSelectedDay] = useState<Date>(new Date(moment.now()));
  const [timesOfTheSelectedDay, setTimesOdTheSelectedDay] = useState<
    string[] | null
  >(null);

  const handleScheduledDelivery = (): void => {
    const mDay = moment(selectedDay);

    if (!selectedHour) {
      setScheduledDelivery(null);
    } else {
      const [hours, minutes] = selectedHour.split(':');
      const day = Number(mDay.format('DD'));
      const month = Number(mDay.format('MM'));
      const year = Number(mDay.format('YYYY'));

      setScheduledDelivery(
        new Date(year, month - 1, day, Number(hours), Number(minutes)),
      );
    }

    addToast({
      type: 'success',
      title: 'Salvo!',
    });

    onClose();
  };

  useEffect(() => {
    const loadSheduledDeliveryDay = async (): Promise<void> => {
      try {
        const {
          data: { dias },
        } = await api.get(`schedules/${user.empresa_id}`);

        Object.keys(dias).forEach((key) => {
          const { start, end } = dias[key][0];

          const hourly = [];
          for (
            let i = Number(start.split(':')[0]);
            i < end.split(':')[0];
            i++
          ) {
            hourly.push(`${i < 10 ? `0${i}` : i}:00`);
          }

          dias[key][0] = hourly;
        });

        setScheduledDeliveryDays(dias);
      } catch (error) {
        addToast({
          type: 'error',
          title: 'Erro ao buscar dias e horários de agendamento.',
        });
      }
    };
    loadSheduledDeliveryDay();
  }, [addToast, user.empresa_id]);

  useEffect(() => {
    if (selectedDay !== undefined && scheduledDeliveryDays !== null) {
      switch (moment(selectedDay).format('dddd')) {
        case 'domingo':
          if (
            scheduledDeliveryDays.dom &&
            scheduledDeliveryDays.dom[0].length > 0
          ) {
            setTimesOdTheSelectedDay(
              JSON.stringify(scheduledDeliveryDays.dom)
                .replace(/\]/g, '')
                .replace(/[\[\"]/g, '')
                .split(','),
            );
          } else {
            setTimesOdTheSelectedDay([]);
          }
          break;
        case 'segunda-feira':
          if (
            scheduledDeliveryDays.seg &&
            scheduledDeliveryDays.seg[0].length > 0
          ) {
            setTimesOdTheSelectedDay(
              JSON.stringify(scheduledDeliveryDays.seg)
                .replace(/\]/g, '')
                .replace(/[\[\"]/g, '')
                .split(','),
            );
          } else {
            setTimesOdTheSelectedDay([]);
          }
          break;
        case 'terça-feira':
          if (
            scheduledDeliveryDays.ter &&
            scheduledDeliveryDays.ter[0].length > 0
          ) {
            setTimesOdTheSelectedDay(
              JSON.stringify(scheduledDeliveryDays.ter)
                .replace(/\]/g, '')
                .replace(/[\[\"]/g, '')
                .split(','),
            );
          } else {
            setTimesOdTheSelectedDay([]);
          }
          break;
        case 'quarta-feira':
          if (
            scheduledDeliveryDays.qua &&
            scheduledDeliveryDays.qua[0].length > 0
          ) {
            setTimesOdTheSelectedDay(
              JSON.stringify(scheduledDeliveryDays.qua)
                .replace(/\]/g, '')
                .replace(/[\[\"]/g, '')
                .split(','),
            );
          } else {
            setTimesOdTheSelectedDay([]);
          }
          break;
        case 'quinta-feira':
          if (
            scheduledDeliveryDays.qui &&
            scheduledDeliveryDays.qui[0].length > 0
          ) {
            setTimesOdTheSelectedDay(
              JSON.stringify(scheduledDeliveryDays.qui)
                .replace(/\]/g, '')
                .replace(/[\[\"]/g, '')
                .split(','),
            );
          } else {
            setTimesOdTheSelectedDay([]);
          }
          break;
        case 'sexta-feira':
          if (
            scheduledDeliveryDays.sex &&
            scheduledDeliveryDays.sex[0].length > 0
          ) {
            setTimesOdTheSelectedDay(
              JSON.stringify(scheduledDeliveryDays.sex)
                .replace(/\]/g, '')
                .replace(/[\[\"]/g, '')
                .split(','),
            );
          } else {
            setTimesOdTheSelectedDay([]);
          }
          break;
        case 'sábado':
          if (
            scheduledDeliveryDays.sab &&
            scheduledDeliveryDays.sab[0].length > 0
          ) {
            setTimesOdTheSelectedDay(
              JSON.stringify(scheduledDeliveryDays.sab)
                .replace(/\]/g, '')
                .replace(/[\[\"]/g, '')
                .split(','),
            );
          } else {
            setTimesOdTheSelectedDay([]);
          }
          break;
        default:
          setTimesOdTheSelectedDay([]);
          break;
      }
    }
  }, [selectedDay, scheduledDeliveryDays]);

  useEffect(() => {
    const format: moment.MomentFormatSpecification = 'HH:mm';

    if (timesOfTheSelectedDay && timesOfTheSelectedDay.length > 0) {
      const temp = timesOfTheSelectedDay.sort(
        (a, b) => (moment(a, format) as any) - (moment(b, format) as any),
      );
      const day = Number(moment(moment.now()).format('DD'));
      const month = Number(moment(moment.now()).format('MM'));
      const day2 = selectedDay.getDate();
      const month2 = selectedDay.getMonth() + 1;

      if (day === day2 && month === month2) {
        const temp2 = temp.filter((option) =>
          moment(moment.now()).isBefore(moment(option, format)),
        );
        setHoursOptions(temp2);
        setSelectedHour(null);
      } else {
        setHoursOptions(temp);
        setSelectedHour(null);
      }
    } else {
      setHoursOptions([]);
      setSelectedHour(null);
    }
  }, [selectedDay, timesOfTheSelectedDay]);

  return (
    <S.CustomModal open onClose={onClose} closeAfterTransition>
      {scheduledDeliveryDays ? (
        <div className="body">
          <S.ModalHeader>
            <h1>Agendar Pedido</h1>
            <button type="button" onClick={onClose}>
              <BiX />
            </button>
          </S.ModalHeader>

          <S.ModalBody>
            <div className="seleted__day">
              <h2>Escolha o dia</h2>
              <S.CustomDivider />
              <ReactDatePicker
                selected={selectedDay}
                minDate={new Date()}
                onChange={(date: Date) => setSelectedDay(date)}
                locale="pt-BR"
                dateFormat="dd/MM/yyyy"
                customInput={<CustomButton />}
              />
            </div>
            <div className="selected__after">
              <h2>Horários</h2>
              <S.CustomDivider />
              <div className="hours__option">
                {hoursOptions.length > 0 ? (
                  hoursOptions.map((option) => (
                    <S.OptionItem
                      key={option}
                      onClick={() =>
                        setSelectedHour((oldState) =>
                          oldState && oldState === option ? null : option,
                        )
                      }
                      selected={option === selectedHour}
                    >
                      <p>{option}</p>
                    </S.OptionItem>
                  ))
                ) : (
                  <p>Nenhum horário disponível para hoje.</p>
                )}
              </div>
            </div>
          </S.ModalBody>

          <S.ModalFooter>
            <Button full onClick={handleScheduledDelivery}>
              Concluir
            </Button>
            <Button full variant="outlined" onClick={onClose}>
              Cancelar
            </Button>
          </S.ModalFooter>
        </div>
      ) : (
        <S.CustomCircularProgress />
      )}
    </S.CustomModal>
  );
};

export default ModalScheduling;
